import type { AfterResponseHook } from 'ky';
import ky from 'ky';
import type { Session } from '../services/types';
import { getEnv } from '../../utils/env';

export const SESSION_TOKEN_NAME = 'caddie-session-token';

const baseUrl = getEnv('BASE_API_URL');

export const retryOnExpiredSession: AfterResponseHook = async (
  request,
  _options,
  response
) => {
  if (response.status === 401 && !request.headers.has('x-retry-attempt')) {
    const { useStoreInfoStore } = await import(
      '../../stores/useStoreInfoStore'
    );
    const refreshedSession = await useStoreInfoStore
      .getState()
      .refreshSession();
    if (refreshedSession?.token) {
      request.headers.set(SESSION_TOKEN_NAME, refreshedSession.token);
      request.headers.set('x-retry-attempt', '1');
      return ky(request);
    }
  }
};

export const api = ky.create({
  prefixUrl: `${baseUrl}/api/`,
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set('x-request-id', crypto.randomUUID());
      },
    ],
    afterResponse: [retryOnExpiredSession],
  },
});

export function createApiHeaders(session?: Session) {
  return {
    ...(session?.token ? { [SESSION_TOKEN_NAME]: session.token } : {}),
  };
}
